import React from 'react'
import { Hidden, Icon } from '@material-ui/core'

import {
    StyledMarkettingSection,
    StyledMarkettingText,
    StyledMarkettingImage,
    StyledMarkettingHeading,
    StyledPartnerSection,
    StyledPartnerButton,
    BulletPoint,
} from './MarkettingSection.style'
import { sizes } from 'utils/screen_sizes'
import SmoothImage from '../SmoothImage/SmoothImage'
import useWindowDimensions from 'app/hooks/useWindowDimensions'
import { useHistory, useLocation } from 'react-router-dom'
import { getCountryFromUrl } from 'utils/CountryUtils'
import { useTranslation } from 'react-i18next'

const MarkettingSection = ({ source = '' }) => {
    const { height, width } = useWindowDimensions()
    const history = useHistory()
    let screenWidth = Number(width)
    let mobileWidth = sizes.mobileL.replace(/\D/g, '')
    const { pathname } = useLocation()
    let country = getCountryFromUrl(pathname)||"ke"
    const { t } = useTranslation()

    function isMobile() {
        if (screenWidth <= Number(mobileWidth)) return true
        else {
            return false
        }
    }

    return (
        <>
            {source ? (
                <StyledPartnerSection>
                    <div className="partner-card">
                        <Hidden mdDown>
                            <StyledPartnerButton
                                onClick={() =>
                                    history.push(
                                        `/${country}/samsung/all-phones`
                                    )
                                }
                            >
                                View more
                            </StyledPartnerButton>
                        </Hidden>
                    </div>
                    <Hidden mdUp>
                        <StyledPartnerButton
                            onClick={() =>
                                history.push(`/${country}/samsung/all-phones`)
                            }
                        >
                            View more
                        </StyledPartnerButton>
                    </Hidden>
                </StyledPartnerSection>
            ) : (
                <StyledMarkettingSection>
                    <div className="marketting-card">
                        <StyledMarkettingText>
                            <StyledMarkettingHeading>
                            {t('description.marketing')}
                            </StyledMarkettingHeading>
                            <BulletPoint>
                                <Icon>favorite</Icon>
                                <div>
                                    <h4> {t('description.marketing_title1')}</h4>
                                    <p>
                                    {t('description.marketing_detail1')}
                                    </p>
                                </div>
                            </BulletPoint>
                            <BulletPoint>
                                <Icon>favorite</Icon>
                                <div>
                                    <h4> {t('description.marketing_title2')}</h4>
                                    <p>{t('description.marketing_detail2')}</p>
                                </div>
                            </BulletPoint>
                            <BulletPoint>
                                <Icon>favorite</Icon>
                                <div>
                                <h4> {t('description.marketing_title3')}</h4>
                                <p>{t('description.marketing_detail3')}</p>
                                </div>
                            </BulletPoint>
                            <BulletPoint>
                                <Icon>favorite</Icon>
                                <div>
                                <h4> {t('description.marketing_title4')}</h4>
                                <p>{t('description.marketing_detail4')}</p>
                                </div>
                            </BulletPoint>
                        </StyledMarkettingText>
                        <StyledMarkettingImage>
                            {isMobile() && (
                                <SmoothImage
                                    src="/assets/images/markettingSection/mid-banner-model.png"
                                    alt="happy customer"
                                    loading="lazy"
                                />
                            )}
                            {!isMobile() && (
                                <SmoothImage
                                    src="/assets/images/markettingSection/mid-banner-model.png"
                                    alt="happy customer"
                                    loading="lazy"
                                />
                            )}
                        </StyledMarkettingImage>
                    </div>
                </StyledMarkettingSection>
            )}
        </>
    )
}

export default MarkettingSection
